import { type AuthUser } from '@/domain/account/types';
import { Role } from '@/domain/user/types';

export const isUserAdmin = (user: Pick<AuthUser, 'role' | 'roles'> | undefined | null) =>
  user != null && (user.role === Role.Admin || (user.roles?.includes(Role.Admin) ?? false));

export const isCanViewCost = (user?: AuthUser) =>
  user?.roles?.some(
    (role) =>
      isUserAdmin(user) ||
      [Role.CustomerCare, Role.ProductManager, Role.ProductOwner, Role.HeadTechnology, Role.CostView].includes(role),
  ) ?? false;

export const isCanTimeAllocation = (user?: AuthUser) =>
  user?.roles?.some((role) => isUserAdmin(user) || Role.TimeAllocation.includes(role)) ?? false;

export const isCanEditPlant = (user?: AuthUser | null) =>
  user != null && (isUserAdmin(user) || (user.roles?.some((role) => [Role.PlantManager].includes(role)) ?? false));
